<ng-container *ngIf="loadingEntitlements && !systemError">
  <div class="loading-page loading-large loginLoading">
    <span class="sr-only">Loading</span>
  </div>
</ng-container>

<ng-container *ngIf="systemError">
  <div class="systemError">
    <div
      data-component="alert-message"
      [data]="{ category: 'error', message: systemError }"
    ></div>
  </div>
</ng-container>

<ng-container *ngIf="!loadingEntitlements">
  <div
    *ngIf="!isMobileView && threatMetrixEnabled"
    data-component="threat-metrix"
    #threatMetrixComponent
  ></div>

  <ul class="nav nav-tabs" equalheight="tab-link" data-test-id="element-tabs">
    <li role="presentation" class="active">
      <a
        [href]="loginUrl"
        (click)="clickLink($event, 'login')"
        class="tab-link"
        tabindex="1"
        aria-label="Login"
        data-test-id="link-login"
        >Log in</a
      >
    </li>
    <li *ngIf="registrationAllowed" role="presentation">
      <a
        [href]="registerUrl"
        (click)="clickLink($event, 'register')"
        class="tab-link"
        tabindex="1"
        aria-label="Register"
        data-test-id="link-register"
        >Register</a
      >
    </li>
  </ul>

  <div
    *ngIf="scaEnabled && !redirectToNonSCA"
    data-component="login-sca"
    #loginSCAComponent
  ></div>

  <div
    *ngIf="!scaEnabled || redirectToNonSCA"
    data-component="login"
    #loginComponent
  ></div>
</ng-container>
